import { restApi } from "../restApi";

export interface OnboardingStatusResponse {
  status: string;
  subscriptionTier?: string;
  unlockedModules?: string[];
  lockedModules?: string[];
}

export interface SuggestionResponse {
  regulations: string[];
  regulators: string[];
  standards: string[];
}

export interface SeedOnboardingRequest {
  industry: string;
  countries: string[];
  selectedRegulations: string[];
  selectedRegulators: string[];
  selectedStandards: string[];
}

export interface ReverseGeocodeResponse {
  address: string;
}

const onboardingApi = restApi.injectEndpoints({
  endpoints: (build) => ({
    getOnboardingStatus: build.query<OnboardingStatusResponse, void>({
      query: () => ({
        url: `/api/v1/onboarding/status`,
        method: "GET",
      }),
      transformResponse: (response: any) =>
        response?.result !== undefined ? response.result : response,
    }),
    optOutOnboarding: build.mutation<void, void>({
      query: () => ({
        url: `/api/v1/onboarding/opt-out`,
        method: "POST",
      }),
      transformResponse: (response: any) =>
        response?.result !== undefined ? response.result : response,
    }),
    getOnboardingSuggestions: build.query<
      SuggestionResponse,
      { countries: string; industry: string }
    >({
      query: ({ countries, industry }) => ({
        url: `/api/v1/onboarding/suggestions`,
        method: "GET",
        params: { countries, industry },
      }),
      transformResponse: (response: any) =>
        response?.result !== undefined ? response.result : response,
    }),
    seedOnboarding: build.mutation<{ success: boolean }, SeedOnboardingRequest>(
      {
        query: (body) => ({
          url: `/api/v1/onboarding/seed`,
          method: "POST",
          body,
        }),
        transformResponse: (response: any) =>
          response?.result !== undefined ? response.result : response,
      },
    ),
    reverseGeocode: build.query<
      ReverseGeocodeResponse,
      { latitude: number; longitude: number }
    >({
      query: ({ latitude, longitude }) => ({
        url: `/api/v1/location/reverse-geocode`,
        method: "GET",
        params: { latitude, longitude },
      }),
      transformResponse: (response: any) =>
        response?.result !== undefined ? response.result : response,
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetOnboardingStatusQuery,
  useLazyGetOnboardingStatusQuery,
  useOptOutOnboardingMutation,
  useGetOnboardingSuggestionsQuery,
  useLazyGetOnboardingSuggestionsQuery,
  useSeedOnboardingMutation,
  useLazyReverseGeocodeQuery,
  useReverseGeocodeQuery,
} = onboardingApi;
